var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({ backgroundColor: _vm.$store.state.questM.questBackColor })},[_c('div',{staticClass:"app_center pa-4 pa-sm-6",staticStyle:{"line-height":"1.7"}},[_c('router-view',{staticStyle:{"max-width":"960px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }